import React, { useState } from 'react';

/**
 * 안전하게 이미지를 표시하는 컴포넌트
 * 이미지 URL이 없거나 로드 실패 시 대체 이미지를 표시합니다.
 * 
 * @param {string} src - 이미지 URL
 * @param {string} alt - 이미지 대체 텍스트
 * @param {object} style - 이미지 스타일
 * @param {string} className - 이미지 CSS 클래스
 * @param {object} placeholderStyle - 대체 배경의 스타일 (기본 회색 배경에 추가 스타일)
 * @param {object} containerStyle - 컨테이너 div 스타일
 * @param {string} containerClassName - 컨테이너 div CSS 클래스
 */
const SafeImage = ({ 
  src, 
  alt = '', 
  style = {}, 
  className = '', 
  placeholderStyle = {},
  containerStyle = {},
  containerClassName = ''
}) => {
  const [hasError, setHasError] = useState(!src);
  
  // 플레이스홀더 스타일
  const defaultPlaceholderStyle = {
    width: "100%",
    height: "100%",
    backgroundColor: "#cccccc",
    ...placeholderStyle
  };
  
  // 컨테이너 스타일
  const defaultContainerStyle = {
    ...containerStyle
  };
  
  // 이미지 로드 실패 핸들러
  const handleImageError = () => {
    setHasError(true);
  };
  
  return (
    <div style={defaultContainerStyle} className={containerClassName}>
      {!hasError && src ? (
        <img
          src={src}
          alt={alt}
          className={className}
          style={style}
          onError={handleImageError}
        />
      ) : (
        <div style={defaultPlaceholderStyle} />
      )}
    </div>
  );
};

export default SafeImage; 